module.exports = __webpack_public_path__ + "img/venta_5.fdfee42b.png";